<template>
  <BaseContainer :title="title" :closeRefresh="true" @cancel="closeModal">
    <component
      :is="Comp[rightsType]"
      :isRenew="isRenew"
      :rights-type="rightsType"
      :user-info="userInfo"
      :behavior="behavior"
      :order_type="order_type"
      :on-close-parent="closeModal"
    />
  </BaseContainer>
</template>

<script setup lang="ts" name="BuyEquity">
import BaseContainer from '../../components/baseContainer/index.vue'
import Rights10Content from './buy-content/rights-10.vue'
import Rights16Content from './buy-content/rights-16.vue'

import { USER_LEVEL_KEY } from '~/api/interface/auth'
import type { ORDER_BEHAVIOR, ORDER_TYPE, UserInfo } from '~/api/interface'

const Comp = {
  [USER_LEVEL_KEY.TASTE]: null,
  [USER_LEVEL_KEY.PERSONAL]: Rights10Content,
  [USER_LEVEL_KEY.PERSONAL_LITE]: Rights10Content,
  [USER_LEVEL_KEY.TEAM_TASTE]: null,
  [USER_LEVEL_KEY.TEAM_LIGHT]: Rights16Content,
  [USER_LEVEL_KEY.ORG_STANDARD]: null,
  [USER_LEVEL_KEY.ORG_FLAGSHIP]: null,
  [USER_LEVEL_KEY.UN_AUTHORIZED]: null,
}

const props = defineProps<{
  title: string
  rightsType: USER_LEVEL_KEY
  isRenew?: boolean
  userInfo: UserInfo
  behavior: ORDER_BEHAVIOR
  order_type: ORDER_TYPE
  onCancel: () => void
}>()

function closeModal() {
  props.onCancel()
}
</script>
